/* eslint-disable */
export default {
  _open_background: 'open_background',
  _results_scroll: 'results_scroll',
  _title: 'title',
  _knife: 'knife',
  _necklace: 'necklace',
  _chest_top: 'chest_top',
  _amulet: 'amulet',
  _vase_small: 'vase_small',
  _ring_small: 'ring_small',
  _idol_small: 'idol_small',
  _idol: 'idol',
  _knife_small: 'knife_small',
  _necklace_small: 'necklace_small',
  _puzzle_number: 'puzzle_number',
  _puzzle_10: 'puzzle-10',
  _vase: 'vase',
  _puzzle_2: 'puzzle-2',
  _let_4: 'let-4',
  _gem: 'gem',
  _cup: 'cup',
  _let_4b: 'let-4b',
  _puzzle_7: 'puzzle-7',
  _ring: 'ring',
  _earrings: 'earrings',
  _chest_lock: 'chest_lock',
  _puzzle_4: 'puzzle-4',
  _puzzle_6: 'puzzle-6',
  _puzzle_9: 'puzzle-9',
  _let_6: 'let-6',
  _mask: 'mask',
  _gem_small: 'gem_small',
  _next_button: 'next_button',
  _crown: 'crown',
  _mystic_1: 'mystic-1',
  _bracelet: 'bracelet',
  _back_button: 'back_button',
  _mystic_10: 'mystic-10',
  _puzzle_8: 'puzzle-8',
  _play_button: 'play_button',
  _cup_small: 'cup_small',
  _orb_shadow: 'orb_shadow',
  _check_mark: 'check_mark',
  _instructions: 'instructions',
  _puzzle_1: 'puzzle-1',
  _bat: 'bat',
  _mask_small: 'mask_small',
  _let_6b: 'let-6b',
  _let_2: 'let-2',
  _let_2b: 'let-2b',
  _let_3: 'let-3',
  _puzzle_13: 'puzzle-13',
  _puzzle_3: 'puzzle-3',
  _puzzle_5: 'puzzle-5',
  _outside_circle: 'outside_circle',
  _outside_circle2: 'outside_circle2',
  _num_1: 'num-1',
  _puzzle_12: 'puzzle-12',
  _coins: 'coins',
  _let_3b: 'let-3b',
  _let_5: 'let-5',
  _let_5b: 'let-5b',
  _let_7: 'let-7',
  _puzzle_11: 'puzzle-11',
  _mystic_11: 'mystic-11',
  _mystic_12: 'mystic-12',
  _mystic_13: 'mystic-13',
  _let_7b: 'let-7b',
  _let_1: 'let-1',
  _crown_small: 'crown_small',
  _let_1b: 'let-1b',
  _mystic_2: 'mystic-2',
  _mystic_3: 'mystic-3',
  _mystic_4: 'mystic-4',
  _num_1b: 'num-1b',
  _num_2: 'num-2',
  _mystic_5: 'mystic-5',
  _mystic_6: 'mystic-6',
  _num_2b: 'num-2b',
  _check_answer_button: 'check_answer_button',
  _num_3: 'num-3',
  _skip_puzzle_button: 'skip_puzzle_button',
  _num_3b: 'num-3b',
  _mystic_7: 'mystic-7',
  _coins_small: 'coins_small',
  _mystic_8: 'mystic-8',
  _mystic_9: 'mystic-9',
  _num_4: 'num-4',
  _num_4b: 'num-4b',
  _num_5: 'num-5',
  _num_5b: 'num-5b',
  _num_6: 'num-6',
  _earrings_small: 'earrings_small',
  _num_6b: 'num-6b',
  _num_7: 'num-7',
  _num_7b: 'num-7b',
  _num_8: 'num-8',
  _num_8b: 'num-8b',
  _bracelet_small: 'bracelet_small',
  _num_9: 'num-9',
  _num_9b: 'num-9b',
  _amulet_small: 'amulet_small',
  _inside_circle: 'inside_circle',
  _inside_circle2: 'inside_circle2',
}